// extracted by mini-css-extract-plugin
export default {"asset":"style_asset__ToHmy","item":"style_item__XBrAb","name":"style_name__uquDs","title":"style_title__Cicqf"};